/*
 *
 * TargetingPeeqPage constants
 *
 */

const scope = 'app/TargetingPeeqPage';

export const ADD_TARGETING_CRITERIA = `${scope}/ADD_TARGETING_CRITERIA`;
export const REMOVE_TARGETING_CRITERIA = `${scope}/REMOVE_TARGETING_CRITERIA`;
export const ADD_NESTING_TARGETING_CRITERIA = `${scope}/ADD_NESTING_TARGETING_CRITERIA`;
export const REMOVE_NESTING_TARGETING_CRITERIA = `${scope}/REMOVE_NESTING_TARGETING_CRITERIA`;
export const UPDATE_TARGETING = `${scope}/UPDATE_TARGETING`;
export const UPDATE_TARGETING_SUCCESS = `${scope}/UPDATE_TARGETING_SUCCESS`;
export const UPDATE_TARGETING_ERROR = `${scope}/UPDATE_TARGETING_ERROR`;
export const STORE_TARGETING_SUCCESS = `${scope}/STORE_TARGETING_SUCCESS`;
export const FETCH_TARGETING = `${scope}/FETCH_TARGETING`;
export const FETCH_TARGETING_PROGRESS = `${scope}/FETCH_TARGETING_PROGRESS`;
export const FETCH_TARGETING_SUCCESS = `${scope}/FETCH_TARGETING_SUCCESS`;
export const FETCH_TARGETING_ERROR = `${scope}/FETCH_TARGETING_ERROR`;
export const FETCH_TARGETING_PEEQ_CRITERIA = `${scope}/FETCH_TARGETING_PEEQ_CRITERIA`;
export const FETCH_TARGETING_PEEQ_CRITERIA_SUCCESS = `${scope}/FETCH_TARGETING_PEEQ_CRITERIA_SUCCESS`;
export const FETCH_TARGETING_PEEQ_CRITERIA_ERROR = `${scope}/FETCH_TARGETING_PEEQ_CRITERIA_ERROR`;

export const UPDATE_VALIDATION_ERRORS = `${scope}/UPDATE_VALIDATION_ERRORS`;

export const SCROLL_TO_FEATURE = `${scope}/SCROLL_TO_FEATURE`;
export const SHOW_ALL_ERRORS = `${scope}/SHOW_ALL_ERRORS`;

export const DELETE_MEDIA = `${scope}/DELETE_MEDIA`;

export const RESUME_SURVEY = `${scope}/RESUME_SURVEY`;
export const RESUME_SURVEY_SUCCESS = `${scope}/RESUME_SURVEY_SUCCESS`;
export const RESUME_SURVEY_ERROR = `${scope}/RESUME_SURVEY_ERROR`;

export const CLEAR_SURVEY = `${scope}/CLEAR_SURVEY`;
export const CLEAR_SURVEY_SUCCESS = `${scope}/CLEAR_SURVEY_SUCCESS`;
export const CLEAR_SURVEY_ERROR = `${scope}/CLEAR_SURVEY_ERROR`;

export const SET_ACTIVE_AUDIENCE = `${scope}/SET_ACTIVE_AUDIENCE`;
export const ADD_AUDIENCE = `${scope}/ADD_AUDIENCE`;
export const ADD_AUDIENCE_SUCCESS = `${scope}/ADD_AUDIENCE_SUCCESS`;
export const ADD_AUDIENCE_ERROR = `${scope}/ADD_AUDIENCE_ERROR`;
export const REMOVE_AUDIENCE = `${scope}/REMOVE_AUDIENCE`;
export const REMOVE_AUDIENCE_SUCCESS = `${scope}/REMOVE_AUDIENCE_SUCCESS`;
export const REMOVE_AUDIENCE_ERROR = `${scope}/REMOVE_AUDIENCE_ERROR`;
export const DUPLICATE_AUDIENCE = `${scope}/DUPLICATE_AUDIENCE`;
export const DUPLICATE_AUDIENCE_SUCCESS = `${scope}/DUPLICATE_AUDIENCE_SUCCESS`;
export const DUPLICATE_AUDIENCE_ERROR = `${scope}/DUPLICATE_AUDIENCE_ERROR`;
export const UPDATE_AUDIENCE = `${scope}/UPDATE_AUDIENCE`;
export const UPDATE_AUDIENCE_SUCCESS = `${scope}/UPDATE_AUDIENCE_SUCCESS`;
export const UPDATE_AUDIENCE_ERROR = `${scope}/UPDATE_AUDIENCE_ERROR`;
export const TOGGLE_AUDIENCE_TEMPLATES = `${scope}/TOGGLE_AUDIENCE_TEMPLATES`;

export const UPDATE_PEEQ_PROJECT_COMPLETES = `${scope}/UPDATE_PEEQ_PROJECT_COMPLETES`;
export const UPDATE_PEEQ_PROJECT_COMPLETES_SUCCESS = `${scope}/UPDATE_PEEQ_PROJECT_COMPLETES_SUCCESS`;
export const UPDATE_PEEQ_PROJECT_COMPLETES_ERROR = `${scope}/UPDATE_PEEQ_PROJECT_COMPLETES_ERROR`;

export const UPDATE_PEEQ_AUDIENCE_SETTINGS = `${scope}/UPDATE_PEEQ_AUDIENCE_SETTINGS`;
export const UPDATE_PEEQ_AUDIENCE_SETTINGS_SUCCESS = `${scope}/UPDATE_PEEQ_AUDIENCE_SETTINGS_SUCCESS`;
export const UPDATE_PEEQ_AUDIENCE_SETTINGS_ERROR = `${scope}/UPDATE_PEEQ_AUDIENCE_SETTINGS_ERROR`;

export const TOGGLE_MODAL = `${scope}/TOGGLE_MODAL`;
export const CLOSE_MODAL = `${scope}/TOGGLE_MODAL`;

export const FETCH_COUNTRIES = `${scope}/FETCH_COUNTRIES`;
export const FETCH_COUNTRIES_SUCCESS = `${scope}/FETCH_COUNTRIES_SUCCESS`;
export const FETCH_COUNTRIES_ERROR = `${scope}/FETCH_COUNTRIES_ERROR`;

export const UPDATE_PEEQ_COUNTRY = `${scope}/UPDATE_PEEQ_COUNTRY`;
export const UPDATE_PEEQ_COUNTRY_SUCCESS = `${scope}/UPDATE_PEEQ_COUNTRY_SUCCESS`;
export const UPDATE_PEEQ_COUNTRY_ERROR = `${scope}/UPDATE_PEEQ_COUNTRY_ERROR`;
export const UPDATE_PEEQ_COUNTRY_MULTI = `${scope}/UPDATE_PEEQ_COUNTRY_MULTI`;
export const UPDATE_PEEQ_COUNTRY_MULTI_SUCCESS = `${scope}/UPDATE_PEEQ_COUNTRY_MULTI_SUCCESS`;
export const UPDATE_PEEQ_COUNTRY_MULTI_ERROR = `${scope}/UPDATE_PEEQ_COUNTRY_MULTI_ERROR`;

export const FETCH_CUSTOM_QUESTIONS = `${scope}/FETCH_CUSTOM_QUESTIONS`;
export const FETCH_CUSTOM_QUESTIONS_SUCCESS = `${scope}/FETCH_CUSTOM_QUESTIONS_SUCCESS`;
export const FETCH_CUSTOM_QUESTIONS_ERROR = `${scope}/FETCH_CUSTOM_QUESTIONS_ERROR`;

export const CREATE_CUSTOM_QUESTION = `${scope}/CREATE_CUSTOM_QUESTION`;
export const CREATE_CUSTOM_QUESTION_SUCCESS = `${scope}/CREATE_CUSTOM_QUESTION_SUCCESS`;
export const CREATE_CUSTOM_QUESTION_ERROR = `${scope}/CREATE_CUSTOM_QUESTION_ERROR`;

export const UPDATE_CUSTOM_QUESTION = `${scope}/UPDATE_CUSTOM_QUESTION`;
export const UPDATE_CUSTOM_QUESTION_SUCCESS = `${scope}/UPDATE_CUSTOM_QUESTION_SUCCESS`;
export const UPDATE_CUSTOM_QUESTION_ERROR = `${scope}/UPDATE_CUSTOM_QUESTION_ERROR`;

export const DELETE_CUSTOM_QUESTION = `${scope}/DELETE_CUSTOM_QUESTION`;
export const DELETE_CUSTOM_QUESTION_SUCCESS = `${scope}/DELETE_CUSTOM_QUESTION_SUCCESS`;
export const DELETE_CUSTOM_QUESTION_ERROR = `${scope}/DELETE_CUSTOM_QUESTION_ERROR`;

export const MODALS = {
  RENAME_AUDIENCE: 1,
  CUSTOM_QUESTION: 2,
  GROUP_ANSWERS: 3,
  NEST_WITH: 4,
  REMOVE_CRITERION: 5,
  REMOVE_AUDIENCE: 6,
  AUDIENCE_TEMPLATE: 7,
  EDIT_AUDIENCE_TEMPLATE: 8,
};

export const initialState = {
  isSaving: false,
  isFetching: false,
  isFetchingPeeqCriteria: false,
  isFetchingCustomQuestions: false,
  isSavingCustomQuestions: false,
  isSavingGroupAnswers: false,
  hasFetched: false,
  hasDifferencesInAudiences: false,
  targetingEditVersion: -1,
  screeningQuestions: [],
  errors: [],
  comments: {},
  audiences: [
    {
      refId: '',
      criteria: [],
    },
  ],
  activeAudienceRefId: null,
  mainCriteria: {},
  customQuestions: {},
  showAudienceTemplates: false,
  modals: {
    [MODALS.RENAME_AUDIENCE]: {
      visible: false,
    },
    [MODALS.CUSTOM_QUESTION]: {
      visible: false,
    },
    [MODALS.GROUP_ANSWERS]: {
      visible: false,
    },
    [MODALS.NEST_WITH]: {
      visible: false,
    },
    [MODALS.REMOVE_CRITERION]: {
      visible: false,
    },
    [MODALS.REMOVE_AUDIENCE]: {
      visible: false,
    },
    [MODALS.AUDIENCE_TEMPLATE]: {
      visible: false,
    },
    [MODALS.EDIT_AUDIENCE_TEMPLATE]: {
      visible: false,
    },
  },
  countries: [],
};

export const NEW_AUDIENCE_COMPLETES = 600;
export const MIN_AUDIENCE_COMPLETES = 10;
export const MIN_SURVEY_INVOICED_COMPLETES = 20;
export const MIN_SURVEY_PREPAID_COMPLETES = 100;
export const MAX_SURVEY_COMPLETES = 20000;

export const AGE_CRITERION_ID = 1;
export const GENDER_CRITERION_ID = 3;
export const GENDER_MALE_VALUE = '1';
export const GENDER_FEMALE_VALUE = '2';
export const GENDER_NON_BINARY_VALUE = '3';

export const HOUSEHOLD_INCOME_US_ID = 34;

export const usFinancialOptionGroups = [
  {
    id: 31,
    text: 'Under $25,000',
    value: '31',
    optionValues: ['1', '2', '3', '4', '5'],
  },
  {
    id: 32,
    text: '$25,000 to $49,999',
    value: '32',
    optionValues: ['6', '7', '8', '9', '10'],
  },
  {
    id: 33,
    text: '$50,000 to $74,999',
    value: '33',
    optionValues: ['11', '12', '13', '14', '15'],
  },
  {
    id: 34,
    text: '$75,000 to $99,999',
    value: '34',
    optionValues: ['16', '17', '18', '19', '20'],
  },
  {
    id: 35,
    text: '$100,000 to $199,999',
    value: '35',
    optionValues: ['21', '22', '23', '24'],
  },
  {
    id: 36,
    text: '$200,000 or more',
    value: '36',
    optionValues: ['25', '26', '27', '28'],
  },
  {
    id: 37,
    text: 'Prefer not to answer',
    value: '37',
    optionValues: ['30'],
  },
];

const HISPANIC_ORIGIN_CRITERION_ID = 5;
const NUMBER_OF_CHILDREN_CRITERION_ID = 41;
const HOUSEHOLD_INCOME_US_CRITERION_ID = 34;
const HOUSEHOLD_INCOME_CANADA_CRITERION_ID = 36;
const AGE_GENDER_OF_CHILDREN_CRITERION_ID = 45;
const RACE_CRITERION_ID = 536;
const ETHNICITY_SIMPLIFIED_CRITERION_ID = 738;
const HOUSEHOLD_INCOME_LEVEL_CRITERION_ID = 1100;

export const MUTUAL_EXCLUSION_CRITERIA = {
  [ETHNICITY_SIMPLIFIED_CRITERION_ID]: [
    HISPANIC_ORIGIN_CRITERION_ID,
    RACE_CRITERION_ID,
  ],
  [RACE_CRITERION_ID]: [ETHNICITY_SIMPLIFIED_CRITERION_ID],
  [HISPANIC_ORIGIN_CRITERION_ID]: [ETHNICITY_SIMPLIFIED_CRITERION_ID],
  [NUMBER_OF_CHILDREN_CRITERION_ID]: [AGE_GENDER_OF_CHILDREN_CRITERION_ID],
  [AGE_GENDER_OF_CHILDREN_CRITERION_ID]: [NUMBER_OF_CHILDREN_CRITERION_ID],
  [HOUSEHOLD_INCOME_US_CRITERION_ID]: [HOUSEHOLD_INCOME_LEVEL_CRITERION_ID],
  [HOUSEHOLD_INCOME_CANADA_CRITERION_ID]: [HOUSEHOLD_INCOME_LEVEL_CRITERION_ID],
  [HOUSEHOLD_INCOME_LEVEL_CRITERION_ID]: [
    HOUSEHOLD_INCOME_US_CRITERION_ID,
    HOUSEHOLD_INCOME_CANADA_CRITERION_ID,
  ],
};

export const GENERAL_TARGETING_ERROR_AUDIENCE = 'all';
